import {
  Clock,
  Crown,
  Heart,
  ShoppingBag,
  Star,
  User,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export type AccountNavGroup = 'trips' | 'rewards' | 'account';

export interface AccountNavItem {
  path: string;
  icon: LucideIcon;
  labelKey: string;
  group: AccountNavGroup;
}

export const ACCOUNT_NAV_ITEMS: AccountNavItem[] = [
  {
    path: '/profile',
    icon: User,
    labelKey: 'account.nav.overview',
    group: 'trips',
  },
  {
    path: '/orders',
    icon: ShoppingBag,
    labelKey: 'account.nav.orders',
    group: 'trips',
  },
  {
    path: '/favorites',
    icon: Heart,
    labelKey: 'account.nav.favorites',
    group: 'trips',
  },
  {
    path: '/travelers',
    icon: Users,
    labelKey: 'account.nav.travelers',
    group: 'trips',
  },
  {
    path: '/history',
    icon: Clock,
    labelKey: 'account.nav.history',
    group: 'trips',
  },
  {
    path: '/wallet',
    icon: Wallet,
    labelKey: 'account.nav.wallet',
    group: 'rewards',
  },
  {
    path: '/points',
    icon: Star,
    labelKey: 'account.nav.points',
    group: 'rewards',
  },
  {
    path: '/membership',
    icon: Crown,
    labelKey: 'account.nav.membership',
    group: 'rewards',
  },
];

export const ACCOUNT_NAV_GROUPS: Array<{
  key: AccountNavGroup;
  labelKey: string;
}> = [
  { key: 'trips', labelKey: 'account.group.trips' },
  { key: 'rewards', labelKey: 'account.group.rewards' },
];

export function isAccountNavItemActive(
  pathname: string,
  item: AccountNavItem,
): boolean {
  return item.path === '/profile'
    ? pathname === '/profile'
    : pathname.startsWith(item.path);
}
